import React, { useEffect, useState } from 'react';
import BackToTop from '../components/elements/BackToTop';
import HeaderStyleEight from '../components/Layout/Header/HeaderStyleEight';
import Footer from './racket-riot-club/Footer';
import ErrorMain from '../components/Error/ErrorMain';

// Breadcrumbs Background Image

const NoPage = () => {

    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("scroll", handleScroll);
        return () => document.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <React.Fragment>
        <HeaderStyleEight />
        {/* SiteBreadcrumb */}
        {/* <SiteBreadcrumb
            pageTitle="404 Error"
            pageName="404 Error"
            breadcrumbsImg={bannerbg}
        /> */}
        {/* SiteBreadcrumb */}
        <ErrorMain/>
        {/*cta-section */}
        {/* <CtaTwo/> */}
        {/*cta-section end */}
        <BackToTop scroll={isVisible} />
        <Footer />
    </React.Fragment>
    );
}

export default NoPage;